import { defaultPwaServiceWorkerPath } from './serviceWorkerAsset';

export interface RegisterPwaServiceWorkerOptions {
  enabled?: boolean;
  path?: string;
  scope?: string;
}

export async function registerPwaServiceWorker(
  options: RegisterPwaServiceWorkerOptions = {},
): Promise<ServiceWorkerRegistration | null> {
  if (
    typeof window === 'undefined' ||
    !('serviceWorker' in navigator) ||
    options.enabled === false
  ) {
    return null;
  }

  let registration: ServiceWorkerRegistration | undefined;
  try {
    registration = await navigator.serviceWorker.register(
      options.path ?? defaultPwaServiceWorkerPath,
      options.scope ? { scope: options.scope } : undefined,
    );
  } catch {
    return null;
  }

  if (!registration) {
    return null;
  }

  const promoteWaitingWorker = (worker: ServiceWorker | null) => {
    worker?.postMessage({ type: 'SKIP_WAITING' });
  };

  promoteWaitingWorker(registration.waiting);
  void registration.update().catch(() => undefined);

  registration.addEventListener('updatefound', () => {
    const installing = registration.installing;

    installing?.addEventListener('statechange', () => {
      if (
        installing.state === 'installed' &&
        navigator.serviceWorker.controller
      ) {
        promoteWaitingWorker(registration.waiting ?? installing);
      }
    });
  });

  return registration;
}
